import {
  bindHover,
  bindMenu,
  usePopupState,
} from 'material-ui-popup-state/hooks';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

import { KeyboardArrowDown } from '@mui/icons-material';

import {
  ButtonDropdown,
  DropdownItem,
  DropdownItemLink,
  DropdownMenu,
} from '../Navbar.styles';

const SettingsMenu = () => {
  const settingsMenuState = usePopupState({ variant: 'popover' });
  const permiteManutencaoEmLote = useSelector(
    (state: RootState) =>
      state.token?.usuario?.permiteManutencaoEmLote ?? false,
  );

  const settingsItems = [
    {
      label: 'Certificado Digital',
      link: `${process.env.REACT_APP_GESTAO_BASE_URL}/main/settings/digital-certificate`,
      visible: true,
    },
    {
      label: 'Cadastro do Contador (Usuários da plataforma)',
      link: `${process.env.REACT_APP_GESTAO_BASE_URL}/main/settings/accountant-registration`,
      visible: true,
    },
    {
      label: 'Cadastro de Empresas e Obrigações',
      link: `${process.env.REACT_APP_GESTAO_BASE_URL}/main/settings/companies-obligations`,
      visible: true,
    },
    {
      label: 'Manutenções em Lote',
      link: `${process.env.REACT_APP_GESTAO_BASE_URL}/main/settings/bulk-updates`,
      visible: permiteManutencaoEmLote,
    },
    {
      label: 'Download do Uploader',
      link: `${process.env.REACT_APP_GESTAO_BASE_URL}/main/settings/uploader/download`,
      visible: true,
    },
  ];

  return (
    <>
      <ButtonDropdown
        {...bindHover(settingsMenuState)}
        endIcon={<KeyboardArrowDown />}
      >
        Configurações
      </ButtonDropdown>
      <DropdownMenu {...bindMenu(settingsMenuState)}>
        {settingsItems.map(
          (item) =>
            item?.visible && (
              <DropdownItemLink href={item.link} key={item.label}>
                <DropdownItem>{item.label}</DropdownItem>
              </DropdownItemLink>
            ),
        )}
      </DropdownMenu>
    </>
  );
};

export default SettingsMenu;
